export const WEB_CLICK_APP_DOWNLOAD = 'web-click-app_download';
export const WEB_CLICK_PARTNER_LANDING_PAGE = 'web-click-partner_landing_page';
export const WEB_CLICK_PROVISION = 'web-click-provision';
export const WEB_CLICK_PROVISION_CODE = 'web-click-provision_code';
export const WEB_VIEW_PARTNER_LANDING_PAGE = 'web-view-partner_landing_page';
